// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/monitoring/v2/logical_type.proto (package ai.h2o.mlops.monitoring.v2, syntax proto3)
/* eslint-disable */

/**
 * Logical types.
 *
 * @generated from enum ai.h2o.mlops.monitoring.v2.LogicalType
 */
export enum LogicalType {
/**
 * Unspecified type
 *
 * @generated from enum value: LOGICAL_TYPE_UNSPECIFIED = 0;
 */
LOGICAL_TYPE_UNSPECIFIED = "LOGICAL_TYPE_UNSPECIFIED",

/**
 * Numerical type
 *
 * @generated from enum value: NUMERICAL = 1;
 */
NUMERICAL = "NUMERICAL",

/**
 * Categorial type
 *
 * @generated from enum value: CATEGORICAL = 2;
 */
CATEGORICAL = "CATEGORICAL",

/**
 * Datetime type
 *
 * @generated from enum value: DATETIME = 3;
 */
DATETIME = "DATETIME",

/**
 * Text type
 *
 * @generated from enum value: TEXT = 4;
 */
TEXT = "TEXT",

/**
 * Image type
 *
 * @generated from enum value: IMAGE = 5;
 */
IMAGE = "IMAGE",

/**
 * Timestamp type
 *
 * @generated from enum value: TIMESTAMP = 6;
 */
TIMESTAMP = "TIMESTAMP",

/**
 * ID type
 *
 * @generated from enum value: ID = 7;
 */
ID = "ID",
}
